import React from 'react'
import index from '../index.css';

const Header = () => {
    return (
        <>
            <nav className="navbar navbar-light bg-light mb-3">
                <div className="w-100">
                    <a className="navbar-brand m-auto d-flex flex-column flex-lg-row justify-content-center">
                        <img src="../favicon_gallery.png" alt="..." className="d-block m-auto align-text-top" style={{width: '10rem'}}/>
                        <span className="m-auto h1Header">Gallery App</span>
                    </a>
                </div>
            </nav>
        </>
    )
}

export default Header
